(() => {
  const SLIDER_SEL = '.mp-testi-slider';

  function initSlider(root) {
    if (!root || root.__mtsInited) return;
    root.__mtsInited = true;

    const testimonials = Array.from(root.querySelectorAll('.mp-testi-testimonial'));
    const pictures = Array.from(root.querySelectorAll('.mp-testi-picture'));
    const prev = root.querySelector('.mp-testi-prev');
    const next = root.querySelector('.mp-testi-next');

    if (!testimonials.length) return;

    let index = 0;
    let intervalId = null;
    let isVisible = true;

    const autoplayEnabled = root.getAttribute('data-autoplay') === '1';
    const autoplayMs = Math.max(1000, parseInt(root.getAttribute('data-autoplay-ms') || '5000', 10));
    const pauseOnHover = root.getAttribute('data-pause-hover') === '1';

    const clampIndex = () => {
      index = ((index % testimonials.length) + testimonials.length) % testimonials.length;
    };

    function measureTallestTestimonial() {
      let tallest = 0;

      testimonials.forEach((el) => {
        const prevDisplay = el.style.display;
        const prevVisibility = el.style.visibility;
        const prevPosition = el.style.position;
        const prevPointerEvents = el.style.pointerEvents;

        el.style.display = 'block';
        el.style.visibility = 'hidden';
        el.style.position = 'absolute';
        el.style.pointerEvents = 'none';

        tallest = Math.max(tallest, el.offsetHeight);

        el.style.display = prevDisplay;
        el.style.visibility = prevVisibility;
        el.style.position = prevPosition;
        el.style.pointerEvents = prevPointerEvents;
      });

      if (tallest > 0) {
        root.style.setProperty('--mts-testimonial-max-height', `${tallest}px`);
      }
    }

    function render() {
      clampIndex();

      testimonials.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.classList.toggle('is-hidden', i !== index);
      });

      pictures.forEach((el, i) => {
        el.classList.toggle('is-active', i === index);
        el.classList.toggle('is-hidden', i !== index);
      });

      root.setAttribute('data-index', String(index));
    }

    function go(delta) {
      index += delta;
      render();
    }

    function stop() {
      if (intervalId) clearInterval(intervalId);
      intervalId = null;
    }

    function start() {
      stop();
      if (!autoplayEnabled) return;
      if (!isVisible || document.hidden) return;

      intervalId = setInterval(() => {
        if (!isVisible || document.hidden) return;
        go(1);
      }, autoplayMs);
    }

    function restartAfterManual() {
      start();
    }

    prev?.addEventListener('click', (e) => {
      e.preventDefault();
      go(-1);
      restartAfterManual();
    });

    next?.addEventListener('click', (e) => {
      e.preventDefault();
      go(1);
      restartAfterManual();
    });

    root.tabIndex = root.tabIndex >= 0 ? root.tabIndex : 0;
    root.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
        restartAfterManual();
      }
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
        restartAfterManual();
      }
    });

    if (pauseOnHover) {
      root.addEventListener('mouseenter', () => stop());
      root.addEventListener('mouseleave', () => start());
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
      else start();
    });

    const io = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        isVisible = !!entry?.isIntersecting;
        if (isVisible) start();
        else stop();
      },
      { threshold: 0.01, rootMargin: '200px 0px' }
    );

    io.observe(root);

    const onResize = () => {
      measureTallestTestimonial();
    };

    window.addEventListener('load', onResize);
    window.addEventListener('resize', onResize);

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => {
        measureTallestTestimonial();
      });
    } else {
      measureTallestTestimonial();
    }

    render();
    measureTallestTestimonial();
    start();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(SLIDER_SEL).forEach((el) => initSlider(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
})();